import strings from '../../../Localization/Localization';

import { store } from '../../../Store/configureStore';

import { fetchPartners } from '../../../API/Partners';
import { fetchPlaces } from '../../../API/Places';
import { fetchPartnerUsers } from '../../../API/Users';

import { timeframe } from '../common';

let title = {
  fieldKey: "title",
  label: strings.form.cart.title.label,
  type: "text",
  showOnDisabled: () => false,
  validators: [],
}

let number = {
  fieldKey: "number",
  label: strings.form.order.number.label,
  type: "text",
  showOnDisabled: () => false,
  validators: [],
}

let installationTicket = {
  fieldKey: "installationTicket",
  label: strings.form.order.installationTicket.label,
  type: "text",
  showOnDisabled: () => false,
  validators: [],
}

export const state = {
  fieldKey: "state",
  label: strings.form.cart.state.label,
  type: "dropdownMulti",
  showOnDisabled: () => false,
  validators: [],

  input: 'options',
  finalValues: 'objects',
  options: [
    {
      value: 'o_w_validation',
      label: strings.form.cart.state.options.order.waitingValidation
    },
    {
      value: 'o_c_period',
      label: strings.form.cart.state.options.order.cancellationPeriod
    },
    {
      value: 'o_w_a_payment',
      label: strings.form.cart.state.options.order.waitingAdvancePayment
    },
    {
      value: 'o_d_i_progress',
      label: strings.form.cart.state.options.order.deliveryInProgress
    },
    {
      value: 'o_d_scheduled',
      label: strings.form.cart.state.options.order.scheduled
    },
    {
      value: 'o_delivered',
      label: strings.form.cart.state.options.order.delivered
    },
    {
      value: 'o_canceled',
      label: strings.form.cart.state.options.order.canceled
    }
  ],
}

let rightToCancellation = {
  fieldKey: "rightToCancellation",
  label: strings.form.order.rightToCancellation.label,
  type: "triswitch",
  disabled: (getValues, getExtraValues) => {
    if(getExtraValues().credentials) {
      let credentials = getExtraValues().credentials();
      return !credentials.roles.includes('ROLE_NYUKOM');
    }
    return true;
  },
  showOnDisabled: () => false,
  validators: [],
}

let client = {
  fieldKey: "client",
  label: strings.form.cart.client.label,
  type: "dropdownEntity",
  showOnDisabled: () => false,
  validators: [],

  showEmpty: true,
  assertObjectDefaultValue: true,
  loader: {
    id: "client",
    loader: fetchPartners,
    loaderRequire: () => true,
    loaderArguments: () => [],
  },

  adapter: {
    requirement: (data) => data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let placeDelivery = {
  fieldKey: "placeDelivery",
  label: strings.form.cart.placeDelivery.label,
  type: "dropdownEntity",
  disabled: (getValues) => getValues(0).client === undefined || getValues(0).client === null || getValues(0).client.id === undefined,
  showOnDisabled: () => false,
  validators: [],

  events: [
    {
      id: "reload",
      event: "onChange",
      target: "client",
      function: (component) => component && component.reloadData()
    }
  ],

  showEmpty: true,
  loader: {
    id: "partnerPlaces",
    loader: fetchPlaces,
    loaderRequire: (value, getValues) => getValues(0) && getValues(0)["client"] && getValues(0)["client"]["id"],
    loaderArguments: (value, getValues) => {
      return [{
        partner_id: getValues(0)["client"]["id"],
        active: 1
      }]
    },
  },

  adapter: {
    requirement: (data) => data["id"] && data["name"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["name"],
  },
}

let clientUser = {
  fieldKey: "clientUser",
  type: "dropdownEntity",
  label: strings.form.cart.clientUser.label,
  showOnDisabled: () => false,
  disabled: (getValues, getExtraValues) => {
    if(getExtraValues().credentials) {
      let credentials = getExtraValues().credentials();
      return !credentials.roles.includes('ROLE_NYUKOM');
    }
    return true;
  },
  validators: [],

  events: [
    {
      id: "reload",
      event: "onChange",
      target: "client",
      function: (component) => component && component.reloadData()
    }
  ],

  showEmpty: true,
  loader: {
    id: "clientUser",
    loader: fetchPartnerUsers,
    loaderRequire: (value, getValues) => getValues(0) && getValues(0)["client"] && getValues(0)["client"]["id"],
    loaderArguments: (value, getValues) => {
      return [{
        partner_id: getValues(0)["client"]["id"]
      }]
    },
  },

  adapter: {
    requirement: (data) => data["id"] && data["displayname"],
    getValue: (data) => data["id"],
    getLabel: (data) => data["displayname"],
  },
}

let validationDateMin = {
  fieldKey: "validationDateMin",
  type: "date",
  label: strings.form.order.validationDateMin.label,
  showOnDisabled: () => false,
  disabled: (getValues, getExtraValues) => {
    if(getExtraValues().credentials) {
      let credentials = getExtraValues().credentials();
      return !credentials.roles.includes('ROLE_NYUKOM');
    }
    return true;
  },
  validators: []
}

let validationDateMax = {
  fieldKey: "validationDateMax",
  type: "date",
  label: strings.form.order.validationDateMax.label,
  showOnDisabled: () => false,
  disabled: (getValues, getExtraValues) => {
    if(getExtraValues().credentials) {
      let credentials = getExtraValues().credentials();
      return !credentials.roles.includes('ROLE_NYUKOM');
    }
    return true;
  },
  validators: []
}

let createdAtMin = {
  fieldKey: "createdAtMin",
  type: "date",
  label: strings.form.cart.createdAtMin.label,
  showOnDisabled: () => false,
  disabled: (getValues, getExtraValues) => {
    if(getExtraValues().credentials) {
      let credentials = getExtraValues().credentials();
      return !credentials.roles.includes('ROLE_NYUKOM');
    }
    return true;
  },
  validators: []
}

let createdAtMax = {
  fieldKey: "createdAtMax",
  type: "date",
  label: strings.form.cart.createdAtMax.label,
  showOnDisabled: () => false,
  disabled: (getValues, getExtraValues) => {
    if(getExtraValues().credentials) {
      let credentials = getExtraValues().credentials();
      return !credentials.roles.includes('ROLE_NYUKOM');
    }
    return true;
  },
  validators: []
}

export const form = {
  formKey: "orderSearch",
  fields: [
    title,
    number,
    installationTicket,
    state,
    rightToCancellation,
    client,
    placeDelivery,
    clientUser,
    Object.assign({}, timeframe, {
      fieldKey: "validationDateTimeframe",
      label: `${strings.form.common.timeframe.label} ${strings.form.order.validationDateTimeframe.label}`
    }),
    validationDateMin,
    validationDateMax,
    Object.assign({}, timeframe, {
      fieldKey: "createdAtTimeframe",
      label: `${strings.form.common.timeframe.label} ${strings.form.cart.createdAtTimeframe.label}`
    }),
    createdAtMin,
    createdAtMax
  ],
  extraValues: {
    credentials: () => store.getState().persisted.credentials
  }
}
